import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

import { useVideoModal } from '../contexts/VideoModalContext'

// Language-specific "So funktioniert Aivy" demo videos
const DEMO_VIDEO_IDS = {
  de: 'YCnoo1-83k8',
  en: 'BFjaZFWbi90'
}

const VideoModal = () => {
  const { isOpen, closeVideo, language } = useVideoModal()

  const videoId = DEMO_VIDEO_IDS[language] || DEMO_VIDEO_IDS.de
  const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`

  return (
    <Dialog
      open={isOpen}
      onClose={closeVideo}
      className="relative z-[100] font-firasans"
    >
      <div
        className="fixed inset-0 bg-dark-black/70 backdrop-blur-md"
        aria-hidden="true"
      />
      <DialogPanel className="fixed inset-0 flex items-center justify-center p-4">
        <div className="relative aspect-video w-full max-w-4xl overflow-hidden rounded-2xl bg-black shadow-2xl">
          <button
            type="button"
            onClick={closeVideo}
            className="absolute right-3 top-3 z-10 grid h-10 w-10 place-items-center rounded-full bg-white/90 text-dark-black hover:bg-white"
            aria-label="Close video"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
          {isOpen && (
            <iframe
              src={videoUrl}
              title="So funktioniert Aivy"
              className="h-full w-full border-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </DialogPanel>
    </Dialog>
  )
}

export default VideoModal
